import * as actions from 'app/actions/legal';
import * as client from 'app/api/contentful-client';

export const fetchWarrantyPage = query => ({
  promise: () => client.getLegalPages(query),
  events: ['PROMISE_PENDING', actions.SET_WARRANTY_PAGE, 'PROMISE_ERROR'],
});

export const fetchPatentPage = query => ({
  promise: () => client.getLegalPages(query),
  events: ['PROMISE_PENDING', actions.SET_PATENT_PAGE, 'PROMISE_ERROR'],
});

export const fetchToSPage = query => ({
  promise: () => client.getLegalPages(query),
  events: ['PROMISE_PENDING', actions.SET_TOS_PAGE, 'PROMISE_ERROR'],
});

export const fetchLegalPages = query => ({
  promise: () => client.getLegalPages(query),
  events: ['PROMISE_PENDING', actions.SET_LEGAL_PAGES, 'PROMISE_ERROR'],
});

export const acceptTermsAndConditions = termsVersion => ({
  promise: async http => (http.post(`/gfcore/users/accept_terms_of_service?minor_version=${termsVersion}`)),
  events: ['PROMISE_PENDING', actions.TERMS_ACCEPTED, 'PROMISE_ERROR'],
});



// WEBPACK FOOTER //
// ./app/api/legal-api.js